const menuItems = [
  {
    id: "mcmv",
    title: "Imóveis MCMV",
    subItems: [
      { label: "Apartamento", href: "" },
      { label: "Casa", href: "" },
    ],
  },
  {
    id: "planta",
    title: "Imóveis na Planta",
    subItems: [
      { label: "Apartamento", href: "" },
      { label: "Casa", href: "" },
      { label: "Sobrado", href: "" },
      { label: "Sala", href: "" },
      { label: "Kitnet", href: "" },
    ],
  },
  {
    id: "novos",
    title: "Imóveis Novos",
    subItems: [
      { label: "Apartamento", href: "" },
      { label: "Casa", href: "" },
      { label: "Sobrado", href: "" },
      { label: "Sala", href: "" },
      { label: "Kitnet", href: "" },
    ],
  },
  {
    id: "sell",
    title: "Venda seu Imóvel",
    href: "", // Item sem dropdown
  },
];

export default menuItems;
